import Axios from "../API/Axios"
import axios from "axios";
import AxiosWOToken  from "../API/Axios";

interface ApiResponse {
  Status: string;
  Data: any;
  Message?: string;
}


// Fetch All Get Data
export const fetchData = async (ControllerName: string, Endpoint: string, CallString: string) => {
  try {
    const response = await Axios.get<ApiResponse>(
      `${ControllerName}/${Endpoint}?${CallString}`
    );
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};
export const fetchDataWOToken = async (ControllerName: string, Endpoint: string, CallString: string) => {
  try {
    const response = await AxiosWOToken.get<ApiResponse>(
      `${ControllerName}/${Endpoint}?${CallString}`
    );
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const postData = async(
  ControllerName: string,
  Endpoint: string,
  payload: any
): Promise<any> => {
  try {
    const response = await Axios.post(
      `${ControllerName}/${Endpoint}`,
      payload
    );
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const postDataWOToken = async(
  ControllerName: string,
  Endpoint: string,
  payload: any
): Promise<any> => {
  try {
    const response = await AxiosWOToken.post(
      `${ControllerName}/${Endpoint}`,
      payload
    );
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// File download — returns a binary blob and triggers browser Save-As.
// Uses the same Axios instance as fetchData so auth headers and base URL are identical.
export const downloadFile = async (
  ControllerName: string,
  Endpoint: string,
  CallString: string,
  filename: string
): Promise<void> => {
  try {
    const response = await Axios.get(
      `${ControllerName}/${Endpoint}?${CallString}`,
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// Centralized error handling function
const handleError = (error: any) => {
  if (axios.isAxiosError(error)) {
    console.error(error);
    return error;
  } else {
    console.error("Unexpected Error:", error);
  }
};
